<template>
  <div class="main">
    <div class="body-content">
      <div class="page-header">
          <h1>Upload Transaction Entry</h1>
      </div>
      <div class="form-group">
        <div class="form-item">
          <label for="partyname">Party *</label>
          <select id="partyname" v-model="newContainer.partyName" class="custom-select" style="width:100%">
            <option v-for="party in party" :key="party.autoid" :value="party.autoid">
              {{ party.short_name }}
            </option>
          </select>
        </div>

        <div class="form-item">
          <label for="vesselName">Vessel *</label>
          <v-select :clearable="false" id="vesselName" placeholder="Select Vessel" v-model="newContainer.vesselID"
            ref="vesselName" :options="vessel" label="Name" :reduce="vessel => vessel.Vesselid" selectOnTab="True" />
        </div>

        <div class="form-item">
          <label for="voyageName">Voyage *</label>
          <v-select :clearable="false" id="voyageName" v-model="newContainer.VoyId" :options="voyage" label="Name"
            :reduce="voyage => voyage.Voyageid" selectOnTab="True" />
        </div>

        <div class="form-item">
          <label for="movementname">Movement Type *</label>
          <v-select :clearable="false" id="movementname" v-model="newContainer.movementID" :options="movementOptions"
            label="Name" :reduce="movement => movement.Movid" selectOnTab="True" />
        </div>

        <div class="form-item">
          <label for="location">Location:</label>
          <v-select :clearable="false" id="location" v-model="newContainer.locID" :options="location" label="Name"
            :reduce="location => location.locationid" selectOnTab="True" />
        </div>
      </div>
      <div class="form-item">
        <label for="fileAdd">File:</label>
        <input type="file" id="file" @change="handleFileUpload" class="custom-file-input">
      </div>
      <div class="form-item">
        <button type="button" class="excel-button" @click="uploadFiles" :disabled="isSubmitting">Upload File</button>
        <button type="button" class="excel-button" @click="savequery" :disabled="isSubmitting">Save</button>
      </div>
    </div>
    <div class="table-container">
      <table class="transaction-table table-design">
        <thead>
          <tr>
            <th>SL no</th>
            <th>Container no</th>
            <th>Date</th>
            <th>Time</th>
            <th>Seal</th>
            <th>To Place</th>
            <th>POL</th>
            <th>POD</th>
            <th>FPD</th>
            <th>Transporter</th>
            <th>Tran Mode</th>
            <th>Booking no</th>
            <th>Haz</th>
            <th>Node</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="ld in fetchedList" :key="ld[0]" class="successful-task">
            <td>{{ ld[0] }}</td>
            <th>
              <span>{{ ld[1] }}</span>
            </th>
            <th>
              <span>{{ formatDate(ld[2]) }}</span>
            </th>
            <th>
              <span>{{ ld[3] }}</span>
            </th>
            <th>
              <span>{{ ld[4] }}</span>
            </th>
            <th>
              <span>{{ ld[5] }}</span>
            </th>
            <th>
              <span>{{ ld[6] }}</span>
            </th>
            <th>
              <span>{{ ld[7] }}</span>
            </th>
            <th>
              <span>{{ ld[8] }}</span>
            </th>
            <th>
              <span>{{ ld[9] }}</span>
            </th>
            <th>
              <span>{{ ld[10] }}</span>
            </th>
            <th>
              <span>{{ ld[11] }}</span>
            </th>
            <th>
              <span>{{ ld[12] }}</span>
            </th>
            <th>
              <span>{{ ld[13] }}</span>
            </th>
            <th>
              <span>{{ ld[14] }}</span>
            </th>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
//import { part } from 'core-js/core/function';
import VSelect from 'vue-select';
import 'vue-select/dist/vue-select.css';
import { useToast } from 'vue-toastification';
import * as cs from '../assets/js/commonscript.js'

export default {
  components: {
    VSelect,
  },
  data() {
    return {
      transactions: [],
      party: JSON.parse(localStorage.getItem('party')),
      accounts: JSON.parse(localStorage.getItem('accounts')) || [],
      applicants: JSON.parse(localStorage.getItem('applicants')) || [],
      vessel: JSON.parse(localStorage.getItem('vessel')) || [],
      voyage: JSON.parse(localStorage.getItem('voyage')) || [],
      movementOptions: JSON.parse(localStorage.getItem('activemovements')) || [],
      ports: JSON.parse(localStorage.getItem('ports')) || [],
      location: JSON.parse(localStorage.getItem('locations')) || [],
      cfs_location: JSON.parse(localStorage.getItem('cfs_location')) || [],
      newContainer: {
        partyName: 0,
        applicantID: 0,
        accountID: 0,
        vesselID: 0,
        VoyId: 0,
        movementID: 0,
        locID: 0,
        file: null,
      },
      htmlContent: null,
      uploadlist: [],
      sqlqry: null,
      isSubmitting: false,
    }
  },
  computed: {
    fetchedList() {
      //console.log(this.uploadlist);
      return this.uploadlist;
    },
  },
  methods: {
    updateApplicantAccountIds(value) {
      const AppAcc = cs.GetAppAccFromParty(value)
      this.newContainer.applicantID = AppAcc.applicantid
      this.newContainer.accountID = AppAcc.accountid
    },
    handleFileUpload(event) {
      this.newContainer.file = event.target.files[0];
    },
    formatDatedt(dateString) {
      return cs.formatDatedt(dateString)
    },
    formatDate(dateString) {
      return cs.formatDate(dateString)
    },
    async uploadFiles() {
      if (this.isSubmitting) return;
      
      this.isSubmitting = true;
      try {
        this.updateApplicantAccountIds(this.newContainer.partyName)
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`, // Include the token in the headers
            'Content-Type': 'multipart/form-data'
          },
        };
        const data = new FormData();
        data.append('file', this.newContainer.file);
        const response = await axios.post('/upload_transaction_entry?applicantid=' + this.newContainer.applicantID + '&accountid=' + this.newContainer.accountID + '&vessselid=' + this.newContainer.vesselID + '&voyageid=' + this.newContainer.VoyId + '&locationid=' + this.newContainer.locID + '&movement=' + this.newContainer.movementID, data, config);
        //console.log(response.data)
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          useToast().success(response.data[1]);
          this.uploadlist = response.data[2]
          this.sqlqry = response.data[3]
          //console.log(this.sqlqry)
          //this.resetNewContainer();
        }
      } catch (error) {
        console.error('Error uploading files:', error);
        useToast().error('An error occurred while uploading files');
      } finally {
        this.isSubmitting = false;
      }
    },
    async savequery() {
      if (this.isSubmitting) return;
      
      if (this.sqlqry === null) {
        useToast().error('Please select a file to upload');
        return;
      }
      
      this.isSubmitting = true;
      try {
        const token = localStorage.getItem('access_token');
        const config = {
          headers: {
            'accept': 'application/json',
            'Authorization': `Bearer ${token}`
          },
        };
        const qrydata = {
          qry: this.sqlqry
        }
        const data = new FormData();
        const transdt = JSON.stringify(qrydata)
        //console.log(this.sqlqry)
        //console.log(transdt)
        data.append('transaction', transdt)

        const response = await axios.post('/upload_transaction_entry_execute', data, config);
        //console.log(response.data)
        if (response.data[0] === 0) {
          useToast().error(response.data[1]);
        } else {
          useToast().success(response.data[1]);
          this.uploadlist = response.data[2]
          this.sqlqry = response.data[3]
          //console.log(this.sqlqry)
          //this.resetNewContainer();
        }
      } catch (error) {
        console.error('Error saving data:', error);
        useToast().error('An error occurred while saving data');
      } finally {
        this.isSubmitting = false;
      }
    },
  }
}

</script>
<style scoped>
/* Form group styling for form elements */
.form-group {
  display: flex;
  flex-wrap: wrap;
  gap: 5px;
  margin-bottom: 5px;
}

.form-item {
  width: 30%;
}

select,
input[type="text"],
input[type="date"],
input[type="number"],
v-select {
  padding: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 14px;
  background-color: #FFF;
}

.excel-button {
  background-color: #17a2b8;
  color: white;
  border: none;
  padding: 10px 15px;
  border-radius: 5px;
  cursor: pointer;
  margin-right: 10px;
}

.excel-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
  opacity: 0.6;
}

.transaction-table {
  width: 100%;
  height: 100%;
  border-collapse: collapse;
}

.transaction-table th,
.transaction-table td {
  padding: 2px 5px;
  text-align: left;
  border-bottom: 1px solid #ddd;
}

.transaction-table th {
  background-color: #f2f2f2;
  font-weight: bold;
}

.transaction-table th .filter-icon {
  cursor: pointer;
  margin-left: 5px;
}
</style>